const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBProgressDraft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-progress-draft",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconB-progress-draft1",
    serifid: "iconB-progress-draft"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,1c6.071,0 11,4.929 11,11c0,6.071 -4.929,11 -11,11c-6.071,0 -11,-4.929 -11,-11c-0,-6.071 4.929,-11 11,-11Zm-0,1.986c-4.975,0 -9.014,4.039 -9.014,9.014c0,4.975 4.039,9.014 9.014,9.014c4.975,-0 9.014,-4.039 9.014,-9.014c-0,-4.975 -4.039,-9.014 -9.014,-9.014Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.154,10.721l-5.295,5.293c-0.143,0.143 -0.319,0.248 -0.512,0.304l-1.568,0.561c-0.115,0.035 -0.175,0.053 -0.208,0.023c-0.032,-0.029 -0.017,-0.099 0.021,-0.21l0.55,-1.579c0.057,-0.192 0.162,-0.369 0.304,-0.511l5.294,-5.295l1.414,1.414Zm0.05,-2.879c0.342,-0.342 0.735,-0.313 1.077,0.029l0.319,0.32c0.342,0.341 0.359,0.723 0.017,1.065l-0.756,0.757l-1.414,-1.413l0.757,-0.758Zm-3.433,-5.806c-0,-0.01 -0,-0.02 -0,-0.031c0,-0.287 0.102,-0.554 0.287,-0.725c0.179,-0.166 0.474,-0.275 0.715,-0.261l0.002,-0c3.351,0.241 6.362,1.975 8.291,4.72c0.001,0.001 0.002,0.002 0.002,0.003c0.156,0.232 0.209,0.519 0.146,0.792c-0.062,0.272 -0.234,0.506 -0.475,0.647l-0.009,0.005c-0.447,0.273 -1.044,0.122 -1.338,-0.313c-1.569,-2.228 -4.055,-3.643 -6.776,-3.844c-0.471,-0.029 -0.845,-0.496 -0.845,-0.967c-0,-0.009 -0,-0.018 0,-0.026Z",
    style: {
      fill: "#808080"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBProgressDraft);
export default __webpack_public_path__ + "static/media/iconB-progress-draft.524db4e19f9ef797185274b29d4359d6.svg";
export { ForwardRef as ReactComponent };